import React from "react";
import { Routes, Route } from "react-router-dom";
import AreaManagers from "../../../Screen/Admin/areaManagers";
import DashboardManagment from "../../../Screen/Admin/DashboardManager";
import { AgentsRoutes } from "../agents/agents_routes";
import Client from "../agents/client";
import NewPreventivo from "../../../Screen/User/newPreventivo";
export const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AreaManagers />} />
      <Route path="dashboardM" element={<DashboardManagment />} />
      <Route path="dashboardM/agents/*" element={<AgentsRoutes />} />
      <Route path="dashboardM/clients" element={<Client />} />
      <Route path="dashboardM/configurations" element={<NewPreventivo />} />
    </Routes>
  );
};
